import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pi-risk" }
const _hoisted_2 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    onHandleNext: _ctx.handleNext,
    current: 2,
    prePathName: "pi"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "title" }, " 风险披露 ", -1)),
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "subtitle" }, "被视为「专业投资者」的风险及后果", -1)),
        _createElementVNode("div", _hoisted_2, [
          _cache[12] || (_cache[12] = _createElementVNode("p", null, " 若阁下被分类成为一位专业投资者，金马证券将能为客户提供只给一位专业投资者的投资机会。 其中，金马证券将能够为客户提供未被证监会认可及/或未受「清盘及杂项条文条例」中有关于招股章程的要求所规管的证券或投资产品。 ", -1)),
          _createElementVNode("p", null, [
            _cache[4] || (_cache[4] = _createTextVNode(" 当客户同意被金马证券界定为一位「个人专业投资者」，金马证券将获豁免遵从 ")),
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPdf(1)))
            }, "操守准则第15.5段"),
            _cache[5] || (_cache[5] = _createTextVNode("所载的条文。其中，金马证券将没有责任： "))
          ]),
          _createElementVNode("p", null, [
            _cache[6] || (_cache[6] = _createTextVNode(" (i) 向客户提供有关金马证券及金马证券雇员及其他代表客户行事的人士的身份和受雇状况的资料（除非客户特别要求有关资料)（ ")),
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPdf(1)))
            }, "操守准则第 8.1 段）"),
            _cache[7] || (_cache[7] = _createTextVNode("； "))
          ]),
          _createElementVNode("p", null, [
            _cache[8] || (_cache[8] = _createTextVNode(" (ii) 当客户完成交易后，尽快向客户确认有关该宗交易的重点（")),
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPdf(1)))
            }, "操守准则第 8.2 段、附表 3 第 4 段及附表 6 第 18 段"),
            _cache[9] || (_cache[9] = _createTextVNode("）﹔及 "))
          ]),
          _createElementVNode("p", null, [
            _cache[10] || (_cache[10] = _createTextVNode(" (iii) 向客户提供关于纳斯达克-美国证券交易所试验计划的资料文件（")),
            _createElementVNode("a", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showPdf(1)))
            }, "操守准则附表 3 第 1 段"),
            _cache[11] || (_cache[11] = _createTextVNode("）。 "))
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("p", null, "金马证券强烈建议客户就下列事项寻求独立专业意见：", -1)),
          _cache[14] || (_cache[14] = _createElementVNode("p", null, "(i) 客户是否愿意被金马证券归类为一名「专业投资者」；及", -1)),
          _cache[15] || (_cache[15] = _createElementVNode("p", null, "(ii) 被金马证券归类为一名「专业投资者」的风险和后果。", -1))
        ]),
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "subtitle" }, " 撤回被视为「专业投资者」的权利 ", -1)),
        _cache[19] || (_cache[19] = _createElementVNode("p", null, " 客户明白，客户有权在任何时候，就所有投资产品及/或市场（或当中任何部份）给予金马证券最少七(7)天的书面通知以反对被视为专业投资者及要求撤回被视为专业投资者的资格。 ", -1)),
        _cache[20] || (_cache[20] = _createElementVNode("p", null, " 客户同意，除非及直至金马证券收到客户有关反对及撤回资格之书面通知，金马证券有权将客户视作专业投资者。任何有关客户撤回专业投资者资格的要求，在该撤回要求生效前，均不会妨碍及影响金马证券向客户提供的服务。 ", -1)),
        _cache[21] || (_cache[21] = _createElementVNode("p", null, " 客户明白，如客户意识到任何可能构成影响符合被视作专业投资者资格的财政状况变化，客户需立即通知金马证券，否则因此导致的后果将由客户自行承担。 ", -1))
      ])
    ]),
    _: 1
  }, 8, ["onHandleNext"]))
}